(function(){
  if(window.__emxProductProLoaded)return;
  window.__emxProductProLoaded=true;

  function getPrimary(){
    return document.querySelector('product-info .product-form__submit');
  }

  function syncBuyState(){
    var primary=getPrimary();
    var sticky=document.querySelector('[data-emx-sticky-add]');
    if(!sticky)return;

    if(!primary){
      if(!sticky.disabled)sticky.disabled=true;
      return;
    }

    var nextDisabled=!!primary.disabled || primary.getAttribute('aria-disabled')==='true';
    if(sticky.disabled!==nextDisabled)sticky.disabled=nextDisabled;

    var txt=(primary.textContent||'').replace(/\s+/g,' ').trim();
    if(txt && (sticky.textContent||'').replace(/\s+/g,' ').trim()!==txt){
      sticky.textContent=txt;
    }

    var sale=document.querySelector('product-info .price .price__sale .price-item--sale');
    var regular=document.querySelector('product-info .price .price__regular .price-item--regular');
    var price=sale || regular;
    var stickyPrice=document.querySelector('[data-emx-sticky-price]');
    if(price&&stickyPrice){
      var nextPrice=(price.textContent||'').trim();
      if(nextPrice && (stickyPrice.textContent||'').trim()!==nextPrice){
        stickyPrice.textContent=nextPrice;
      }
    }
  }

  function copyDynamicFact(sourceRoot,selector){
    if(!sourceRoot || typeof sourceRoot.querySelector!=='function')return;
    var source=sourceRoot.querySelector(selector);
    var destination=document.querySelector(selector);
    if(!source||!destination)return;
    if(destination.innerHTML!==source.innerHTML)destination.innerHTML=source.innerHTML;
    if(destination.hidden!==source.hidden)destination.hidden=source.hidden;
  }

  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-emx-sticky-add]');
    if(!btn)return;
    e.preventDefault();
    var primary=getPrimary();
    if(primary&&!primary.disabled&&primary.getAttribute('aria-disabled')!=='true')primary.click();
  });

  function boot(){
    syncBuyState();

    var primary=getPrimary();
    if(primary&&window.MutationObserver){
      new MutationObserver(function(){
        window.requestAnimationFrame(syncBuyState);
      }).observe(primary,{
        attributes:true,
        attributeFilter:['disabled','aria-disabled']
      });
    }

    if(typeof subscribe==='function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange){
      subscribe(PUB_SUB_EVENTS.variantChange,function(payload){
        var html=payload&&payload.data&&payload.data.html;
        copyDynamicFact(html,'[data-emx-fact-sku]');
        copyDynamicFact(html,'[data-emx-fact-stock]');
        window.requestAnimationFrame(syncBuyState);
      });
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }
})();
